import React from 'react';
import { useDispatch } from 'react-redux';

import { Button, Col, Form, Input, Modal, Row } from 'antd';

import { NewGuideStatus } from 'app/redux/actions/initiatives';

const NewGuideStatusModal = ({ show, setShow }) => {
  const dispatch = useDispatch();

  const Close = () => {
    setShow(false);
  };

  const onFinish = async values => {
    await dispatch(NewGuideStatus(values));
    window.location.reload();
  };

  return (
    <Modal footer={null} open={show} onCancel={Close} width="600px">
      <div className="modal-body">
        <Form onFinish={onFinish}>
          <Form.Item name="title" label="Title" rules={[{ required: true }]}>
            <Input showCount maxLength={50} />
          </Form.Item>

          <Form.Item
            name="description"
            label="Description"
            rules={[{ required: true }]}
          >
            <Input showCount maxLength={50} />
          </Form.Item>

          <Row gutter={(4, 4)}>
            <Col>
              <Form.Item labelCol={{ span: 6 }}>
                <Button type="primary" htmlType="submit">
                  Submit
                </Button>
              </Form.Item>
            </Col>
            <Col>
              <Form.Item wrapperCol={{ span: 6 }}>
                <Button onClick={() => Modal.destroyAll()}>Cancel</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </Modal>
  );
};

export default NewGuideStatusModal;
